import React from "react";
import Add from "./Add";
import Edit from "./Edit";
import Overview from "./Overview";
import { TeamProvider } from "../../context/TeamContext";
// import { useAdminContext } from "../../context/admin/AdminContext";
// import { Navigate } from "react-router-dom";

// Redirect to home
// const ReturnHome = () => {
//   const { sysAdmin } = useAdminContext();
//   if (sysAdmin.role !== "admin")
//     return (
//       <Navigate
//         replace
//         to="/"
//       />
//     );
//   else return null;
// };

export const Team = () => {
  return (
    <TeamProvider>
      {/* <ReturnHome /> */}
      <Overview />
    </TeamProvider>
  );
};

export const AddTeam = () => {
  return (
    <TeamProvider>
      {/* <ReturnHome /> */}
      <Add />
    </TeamProvider>
  );
};

export const EditTeam = () => {
  return (
    <TeamProvider>
      {/* <ReturnHome /> */}
      <Edit />
    </TeamProvider>
  );
};
